<template>
  <div class="relative select-wrapper">
    <img src="/img/icons/swap_vertical_circle.svg" class="custom-icon dark:filter dark:invert dark:invert-1 pr-5" />
    <select
      class="select-class w-14 lg:w-full border-2 bg-white dark:bg-black border-gray-300 py-2 px-0 lg:pl-12 lg:pr-9 rounded-full indent-[100%] lg:indent-0"
      v-model="selectedKey"
      @change="handleSelect"
    >
      <option v-for="[key, option] in Object.entries(options)" :key="key" :value="key">
        {{ option.label }}
      </option>
    </select>
    <img
      src="/img/icons/keyboard_arrow_down.svg"
      class="custom-arrow dark:filter dark:invert dark:brightness-0 hidden lg:block"
    />
  </div>
</template>

<script setup>
// Define props
const props = defineProps({
  options: {
    type: Object,
    required: true,
  },
  selectedKey: {
    type: String,
    default: '',
  },
  onSelect: {
    type: Function,
    required: true,
  },
});

// Define emits
const emit = defineEmits(['update:selectedKey']);

// Local state
const selectedKey = ref(props.selectedKey);

// Computed properties
const selectedLabel = computed(() => {
  return props.options[selectedKey.value]?.label || 'Select';
});

// Methods
const handleSelect = (event) => {
  const key = event.target.value;
  props.onSelect(key);
  emit('update:selectedKey', key);
};
</script>

<style scoped>
.select-wrapper {
  position: relative;
  display: inline-block;
}

.select-class {
  appearance: none;
}

/* Hide text on mobile */
@media (max-width: 640px) {
  .select-class {
    text-indent: 100%; /* Push text off screen */
    white-space: nowrap; /* Prevent text wrapping */
    overflow: hidden; /* Hide overflow text */
  }
}

.custom-arrow {
  position: absolute;
  right: 1em;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.custom-icon {
  position: absolute;
  left: 1em;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}
</style>
